<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<div class="columns column6">
				<h2 v-if="page.subtitle" class="subtitle">
					{{ page.subtitle }}
				</h2>
				<h1>{{ page.title || page.header }}</h1>
				<div v-parse-links v-html="page.content" />
			</div>
			<div class="columns column6">
				<div class="form-wrapper">
					<contact-form name="contact" :form="form" />
				</div>
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>

		<section class="maps-section">
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2453.8509582780284!2d4.849257176925123!3d52.04602737121245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c678f9d1ae7a6f%3A0x5ba24daa7ce87762!2sDe%20Dijketelg!5e0!3m2!1snl!2snl!4v1700817252281!5m2!1snl!2snl"
				width="100%"
				height="550"
				style="border: 0"
				allowfullscreen
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
			/>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();

if (!defaults.value) {
	await fetchDefaults();
}

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
}

.form-wrapper {
	padding: 40px 30px;
	background: var(--cta-color);
}
</style>
